import { AssetLoader } from '@/shared/utils';
import GemiusStreamEmitter from './gemius-emitter';

export default async ({ $deferredLoader, $oneTrust, $services, $stats }) => {
  const info = $services.resolve('info');
  const liveManager = $services.resolve('liveManager');
  const subscriber = $services.resolve('subscriber');

  await info.fetch();
  const { hitStreamCollectorHost, scriptStreamIdentifier } = info.gemiusInfo || {};

  if (!hitStreamCollectorHost || !scriptStreamIdentifier) {
    return;
  }

  window.pp_gemius_player_identifier = scriptStreamIdentifier;
  window.pp_gemius_player_id = scriptStreamIdentifier;

  window.gemius_player_pending = (obj, fun) => {
    obj[fun] = obj[fun] || function () {
      window.gemius_player_data = window.gemius_player_data || [];
      window.gemius_player_data.push([this, fun]);
    };
  };

  window.gemius_player_pending(window, 'GemiusPlayer');
  window.gemius_player_pending(window.GemiusPlayer.prototype, 'newProgram');
  window.gemius_player_pending(window.GemiusPlayer.prototype, 'newAd');
  window.gemius_player_pending(window.GemiusPlayer.prototype, 'adEvent');
  window.gemius_player_pending(window.GemiusPlayer.prototype, 'programEvent');
  window.gemius_player_pending(window.GemiusPlayer.prototype, 'setVideoObject');

  const emitter = new GemiusStreamEmitter($stats, subscriber, $oneTrust, liveManager);
  $stats.registerEmitter(emitter);

  Promise.all([
    $deferredLoader.appReady.promise,
    $deferredLoader.oneTrust.promise,
  ])
    .then(() => new AssetLoader().load([
      { id: 'gemiusStream', src: `${hitStreamCollectorHost}/gplayer.js` },
    ], { async: true, defer: true }))
    .then(() => {
      emitter.activate();
    })
    .catch(() => {});
};
